import React, {useState} from "react";
import styles from './Styles.module.scss';
import Layout from "@/components/layout/Layout";
import Button from "@/components/button/Button";
import {useForm} from "react-hook-form";
import TextInput from "@/components/input/text/TextInput";
import EmailInput from "@/components/input/email/EmailInput";
import PhoneInput from "@/components/input/phone/PhoneInput";
import MessageInput from "@/components/input/message/MessageInput";
import BackButton from "@/components/button/back/BackButton";
import RadioButton from "@/components/button/radiobutton/RadioButton"
import classNames from 'classnames/bind';
import {sendContactForm} from "@/lib/api/api";
import {useRouter} from 'next/router'
import {useContext} from "@/lib/utils/context";
import BreadcrumbSchema from "@/components/schema/BreadcrumbSchema";

export default function ContactUs() {
  const router = useRouter();
  const [enquiryType, setEnquiryType] = useState("GENERAL");

  const {site} = useContext();
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (data) => {
    const payload = {
      ...data,
      enquiryType
    }
    try {
      setSubmitting(true);
      await sendContactForm(payload)
    } catch (e) {
      console.log(e);
    } finally {
      await router.push("/contact-confirmation");
      setSubmitting(false);
    }
  };

  const {register, handleSubmit} = useForm();

  const enquiryTypes = [
    {value: "GENERAL", label: "GENERAL ENQUIRIES"},
    {value: "SUBSCRIPTION", label: "SUBSCRIPTION ENQUIRIES"},
  ]

  const onEnquiryTypeChanged = (value) => {
    setEnquiryType(value);
  }

  return (
      <Layout nav>
        <BreadcrumbSchema crumbs={[{name: "Contact Us", path: "contact-us"}]}/>
        <div className={styles.container}>
          <div className={styles.headerContainer}>
            <div className={styles.header}>
              <BackButton className={styles.back}/>
              <h1>Contact Us</h1>
            </div>
          </div>
          <div className={styles.content}>
            <h2>Get in touch</h2>
            <form id={"contactUsForm"} onSubmit={handleSubmit(onSubmit)}>
              <RadioButton
                  className={styles.radio}
                  name="Radio"
                  options={enquiryTypes}
                  value={enquiryType}
                  onValueChange={onEnquiryTypeChanged}
              />

              <div className={styles.fieldGroups}>
                <div className={classNames(styles.fieldGroup, styles.singleLineFields)}>
                  <div className={styles.field}>
                    <TextInput
                        name="firstName"
                        placeholder="First Name"
                        pattern="(.*\S+.*)+"
                        required
                        register={register({})}
                    />
                  </div>
                  <div className={styles.field}>
                    <TextInput
                        name="lastName"
                        placeholder="Last Name"
                        required
                        pattern="(.*\S+.*)+"
                        register={register({})}
                    />
                  </div>
                  <div className={styles.field}>
                    <EmailInput
                        required
                        name="email"
                        pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                        register={register}
                    />
                  </div>
                  <div className={styles.field}>
                    <PhoneInput
                        required
                        type="tel"
                        placeholder="Phone"
                        name="phone"
                        pattern="[0-9-\+\s\-]{1,}"
                        register={register}
                    />
                  </div>
                </div>

                <div className={classNames(styles.fieldGroup, styles.message)}>
                  <MessageInput
                      name="message"
                      className={styles.messageInput}
                      form={"contactUsForm"}
                      placeholder="Message"
                      required
                      register={register}
                  />
                </div>
              </div>

              <div className={styles.buttonContainer}>
                <Button
                    solid
                    submitting={submitting}
                    className={styles.button2}
                >
                  SEND NOW
                </Button>
              </div>
            </form>

            <div className={styles.bottomPart}>
              <div className={styles.chat}>
                <h2>Let's chat</h2>
                <p>General enquiries: <a href={"tel:+6499126640"}>+64&nbsp;9&nbsp;912&nbsp;6640</a></p>
                <p>Subscription enquiries: <a href={"tel:0800776247"}>0800&nbsp;776&nbsp;247</a></p>
              </div>
              <div className={styles.addressAndMap}>
                <h2>Office Address</h2>
                <p>{site.name} Magazine</p>
                <p>
                  22 Stanley Street <br/>
                  Auckland Central <br/>
                  Auckland 1010 <br/>
                </p>
                <p>
                  <a href={"https://www.google.co.nz/maps/place/22+Stanley+Street,+Auckland+CBD,+Auckland+1010/@-36.8518618,174.7725358,17z/data=!3m1!4b1!4m5!3m4!1s0x6d0d480840eba701:0x25e4c1015fda574d!8m2!3d-36.8518618!4d174.7747298?hl=en-GB&authuser=0"}
                     target="_blank">
                    View map
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.blankSpace}>
          &nbsp;
        </div>
      </Layout>
  )
}
